var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcellence(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_129122",
    "data-name": "Group 129122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.453,
    height: 55.767,
    viewBox: "0 0 47.453 55.767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37644",
    "data-name": "Rectangle 37644",
    width: 47.452,
    height: 55.766,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_129122-2",
    "data-name": "Group 129122",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113194",
    "data-name": "Path 113194",
    d: "M5.647,9.511l5.344-8.333L29.022,1l5.844,8.85L20.026,26.317Z",
    transform: "translate(3.437 3.547)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113195",
    "data-name": "Path 113195",
    d: "M17.161,1.148,14.034,9.292,20.8,24.364l6-15.225-1.251-3.1L23.415.757",
    transform: "translate(2.808 3.566)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113196",
    "data-name": "Path 113196",
    d: "M1.079,32.337,10.4,31.211a13.119,13.119,0,0,1,7.322,1.232l8.82,4.3a4.136,4.136,0,0,1-3.17,7.624l-5.453-1.9",
    transform: "translate(0.113 3.267)",
    fill: "none",
    stroke: "#18a6ef",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113197",
    "data-name": "Path 113197",
    d: "M29.272,39.893l12.734-2.338a3.652,3.652,0,0,1,1.69,7.1L24.37,50.332a9.682,9.682,0,0,1-5.533-.02L.289,44.716",
    transform: "translate(0.03 3.936)",
    fill: "none",
    stroke: "#18a6ef",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellence);
export default __webpack_public_path__ + "static/media/excellence.aebd4abca2ffb1ce905bd6e2eb31c310.svg";
export { ForwardRef as ReactComponent };